import { VERIFICATION_METHODS } from "../utils/Constants";
import { ROUTE_PATHS } from "../utils/RoutesPaths";

export const clickActions = {
  productRequest: "Product details",
  categorySuggestion: "Request details",
  onlineVerificationRequest: "Online verification request",
  banktransferVerificationRequest:
    "Bank transfer verification request",
  offplatformVerificationRequest: "Off platform verification request",
  offplatformVerificationRequestUpdate:
    "Off platform verification request update",
  permissionsChanged: "Permissions changed",
  accountDeactivated: "Account deactivated"
};

export const notificationsActions = [
  {
    clickAction: clickActions.productRequest,
    route: ROUTE_PATHS.productDetailsRequest,
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.categorySuggestion,
    route: ROUTE_PATHS.categoriesRequestsDetails,
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.onlineVerificationRequest,
    route: ROUTE_PATHS.verificationRequestDetails.replace(
      ":type",
      VERIFICATION_METHODS.onlinePayment
    ),
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.banktransferVerificationRequest,
    route: ROUTE_PATHS.verificationRequestDetails.replace(
      ":type",
      VERIFICATION_METHODS.bankTransfer
    ),
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.offplatformVerificationRequest,
    route: ROUTE_PATHS.verificationRequestDetails.replace(
      ":type",
      VERIFICATION_METHODS.offPlatform
    ),
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.offplatformVerificationRequestUpdate,
    route: ROUTE_PATHS.verificationRequestDetails.replace(
      ":type",
      VERIFICATION_METHODS.offPlatform
    ),
    actionIdKey: ":id"
  },
  {
    clickAction: clickActions.permissionsChanged,
    route: ROUTE_PATHS.login
  },
  {
    clickAction: clickActions.accountDeactivated,
    route: ROUTE_PATHS.login
  }
];
